import axios from "axios";

const state = {
  types: {
    loading: false,
    list: null
  },
  instruments: {
    loading: false,
    list: null
  },
  tags: {
    cancelTokenSource: null,
    loading: false,
    list: null
  },
  added: {
    loading: false,
    list: [
      { id: 0, name: "All Time" },
      { id: 1, name: "Today" },
      { id: 7, name: "Last 7 Days" },
      { id: 30, name: "Last 30 Days" },
      { id: 192, name: "Last 6 months" },
      { id: 365, name: "Last 12 months" },
    ]
  },
  sortBy: {
    loading: false,
    list: [
      { id: 'latest', name: 'Newest' },
      { id: 'oldest', name: 'Oldest' },
      { id: 'plays', name: 'Most Plays' },
    ]
  }
};

const mutations = {
  types(state, payload) {
    state.types = {
      ...state.types,
      ...payload
    };
  },
  instruments(state, payload) {
    state.instruments = {
      ...state.instruments,
      ...payload
    };
  },
  tags(state, payload) {
    state.tags = {
      ...state.tags,
      ...payload
    };
  },
  added(state, payload) {
    state.added = {
      ...state.added,
      ...payload
    };
  },
  sortBy(state, payload) {
    state.sortBy = {
      ...state.sortBy,
      ...payload
    };
  }
};

const actions = {
  async loadTypes({ state, commit }) {
    if (!state.types.list && !state.types.loading) {
      try {
        commit("types", { loading: true });
        const list = (await axios.get(`${ab.apiUrl}/soundTypes`)).data.items;
        commit("types", { loading: false, list });
      } catch {
      }
    }
  },
  async loadInstruments({ commit }) {
    if (!state.instruments.list && !state.instruments.loading) {
      try {
        commit("instruments", { loading: true });
        const list = (await axios.get(`${ab.apiUrl}/instruments`)).data.items;
        commit("instruments", { loading: false, list });
      } catch {
      }
    }
  },
  async loadTags({ state, commit }, query) {
    try {
      if (state.tags.cancelTokenSource) {
        state.tags.cancelTokenSource.cancel();
      }
      const cancelTokenSource = axios.CancelToken.source();
      await commit("tags", { loading: true, cancelTokenSource });
      const list = (await axios.get(`${ab.apiUrl}/tags?input=${query}&limit=10`, {
        cancelToken: cancelTokenSource.token
      })).data.items;
      await commit("tags", { loading: false, list, cancelTokenSource: null });
    } catch {
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
